module.exports = __webpack_public_path__ + "img/MULTI_ROLE_A1010.9c8ea51e.png";